// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"97345a0ad5b0ece733fe","147":"966df311d64078edeb01","251":"91532f898d59a87aaf48","265":"bdab3b8250d5ce5ad886","352":"bc6a8a8454ff274878ff"}[chunkId] + ".js";
};